import * as z from 'zod';

export const IncorporationDetailsSchema = z.object({
  formationDate: z
    .string()
    .min(1, 'Corporation formation date is a required field'),
    corporationName: z
    .string()
    .trim()
    .min(1, 'Please enter a valid corporation name.'),
  shareCount: z
    .number({
      invalid_type_error: 'Please enter total number of shares issued.',
      required_error: 'Please enter total number of shares issued.',
    })
    .positive('Number of shares must be greater than 0')
    .int('Number of shares must be a whole number'),
});

export type IncorporationDetailsSchemaFields = z.infer<
  typeof IncorporationDetailsSchema
>;
